export default __webpack_public_path__ + "static/media/abver.e7da25d0.jfif";